/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Stage_TitleInputs */

const en_mk_abt_stage_title = /** @type {(inputs: Mk_Abt_Stage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where this product is right now`)
};

const id_mk_abt_stage_title = /** @type {(inputs: Mk_Abt_Stage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk ini ada di mana sekarang`)
};

/**
* | output |
* | --- |
* | "Where this product is right now" |
*
* @param {Mk_Abt_Stage_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_stage_title = /** @type {((inputs?: Mk_Abt_Stage_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Stage_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_stage_title(inputs)
	return en_mk_abt_stage_title(inputs)
});